import type { ApiListResponse, Campus, School } from "@academia-hub/shared-types";
import { fetchAllRows } from "../lib/fetch-all-pages.js";

/** Every school of the tenant — the header's school switcher (a school group can pass the API's default page of 20). */
export function fetchSchools(): Promise<ApiListResponse<School>> {
  return fetchAllRows<School>("/schools");
}

/** Every campus of one school — the header's campus switcher and campus pickers. */
export function fetchCampuses(schoolId: string): Promise<ApiListResponse<Campus>> {
  return fetchAllRows<Campus>("/campuses", new URLSearchParams({ schoolId }));
}

/** Every campus in the tenant (all schools) — for labelling campus scopes on the Users screen. */
export function fetchAllCampuses(): Promise<ApiListResponse<Campus>> {
  return fetchAllRows<Campus>("/campuses");
}
